import { AioExternalReplacements } from "aic";
import { hasStylesInReplacementValues } from "components/tlfpage/remove-style-functions/hasStylesInReplacementValues";
import { IEditorV3 } from "editor-v3";

/**
 * Checks if any external replacement list contains Optional or Notes styles that will be removed.
 * Recursively checks nested subLists.
 *
 * @param lists - Array of external replacement lists with EditorV3 content
 * @returns True if any list contains styles to be removed, false otherwise
 */
export const hasStylesToRemoveInLists = (lists: AioExternalReplacements<IEditorV3>[]): boolean => {
  return lists.some((list) => hasStylesInReplacementValues(list.newTexts));
};
